module.exports = __webpack_public_path__ + "dist/media/ec_comp_inpage-navigation.7c5bba75.svg";